import React from "react";
import { cspOpportunityCountLabel } from "../utils/cspCostOptimization";

export const CSP_BOOKING_URL = "https://bookings.cloud.microsoft/bookwithme/user/0ffbacb1a4f5475086c3097c1f761a24%40patriotconsulting.com?anonymous&ismsaljsauthenabled";

const cardStyle = {
  border: "1px solid rgba(68,166,255,.34)", borderRadius: 12,
  background: "linear-gradient(135deg,rgba(21,54,95,.9),rgba(11,31,58,.98))",
  padding: "16px", marginBottom: 16,
};

export const CspBookingLink = ({ children = "Book a CSP review" }) => (
  <a href={CSP_BOOKING_URL} target="_blank" rel="noopener noreferrer" style={{
    display: "inline-block", borderRadius: 8, padding: "9px 12px", background: "#44a6ff",
    color: "#071a31", fontWeight: 800, fontSize: 13, textDecoration: "none",
  }}>{children}</a>
);

export const CspOverviewPrompt = ({ opportunity, onExplore }) => {
  if (opportunity.eligibility !== "eligible" || opportunity.topics.length === 0 || opportunity.hidden) return null;
  const count = opportunity.topics.length;
  return (
    <section style={cardStyle} aria-label="CSP Cost Optimization">
      <div style={{ color: "#edf4ff", fontWeight: 800, fontSize: 16 }}>Your licensing is worth a closer look.</div>
      <p style={{ color: "#a8bddc", margin: "7px 0 12px", lineHeight: 1.5, fontSize: 13 }}>
        We identified {cspOpportunityCountLabel(count)} in your license mix to review for potential savings.
      </p>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <button type="button" onClick={onExplore} style={{ background: "none", color: "#8bc5ff", border: 0, padding: 0, cursor: "pointer", font: "inherit", fontWeight: 700 }}>Explore opportunities</button>
        <button type="button" onClick={() => opportunity.setHidden(true)} style={{ background: "none", color: "#a8bddc", border: 0, padding: 0, cursor: "pointer", font: "inherit" }}>Hide</button>
      </div>
      {opportunity.preferencePersistence === "session" && <p style={{ color: "#a8bddc", margin: "10px 0 0", fontSize: 12 }}>Your preference is saved for this session only.</p>}
    </section>
  );
};

export const CspLicensingPanel = ({ opportunity }) => {
  if (!opportunity.snapshot || opportunity.snapshot.available !== true) return null;
  const eligible = opportunity.eligibility === "eligible";
  const topics = opportunity.topics || [];
  return (
    <section style={cardStyle} aria-label="CSP Cost Optimization review">
      {eligible && topics.length > 0 ? <>
        <div style={{ color: "#edf4ff", fontWeight: 800, fontSize: 16 }}>Your license mix may offer opportunities to save.</div>
        <p style={{ color: "#a8bddc", margin: "7px 0 12px", lineHeight: 1.5, fontSize: 13 }}>
          We identified {cspOpportunityCountLabel(topics.length)} worth a closer look. Review them with Patriot to see what makes sense for your team.
        </p>
        {topics.map((topic) => <details key={topic.id} style={{ borderTop: "1px solid rgba(255,255,255,.12)", padding: "10px 0" }}>
          <summary style={{ cursor: "pointer", color: "#edf4ff", fontWeight: 700 }}>{topic.title}</summary>
          <p style={{ color: "#a8bddc", margin: "8px 0 0", lineHeight: 1.5, fontSize: 13 }}>{topic.explanation}</p>
          {topic.qualification && <p style={{ color: "#a8bddc", margin: "8px 0 0", lineHeight: 1.5, fontSize: 12 }}>{topic.qualification}</p>}
        </details>)}
        <p style={{ color: "#a8bddc", margin: "8px 0 12px", lineHeight: 1.5, fontSize: 12 }}>Any savings depend on your current pricing, licensing needs and agreement.</p>
      </> : <p style={{ color: "#a8bddc", margin: "0 0 12px", lineHeight: 1.5, fontSize: 13 }}>Meet with a Patriot CSP specialist to review your Microsoft licensing and explore potential savings.</p>}
      <CspBookingLink />
      {opportunity.hidden && <div style={{ marginTop: 12 }}>
        <button type="button" onClick={() => opportunity.setHidden(false)} style={{ background: "none", color: "#8bc5ff", border: 0, padding: 0, cursor: "pointer", font: "inherit", fontWeight: 700 }}>Show</button>
        <span style={{ color: "#a8bddc", fontSize: 12 }}> · {opportunity.preferencePersistence === "session" ? "Your preference is saved for this session only." : "This preference applies to this browser."}</span>
      </div>}
    </section>
  );
};
